// import indianserver from "./IndianServers.jpeg"
import amex from "../../assets/companies/amex.png"
const timelineElements=[
    {
        id: 1,
        Name: "American Express",
        Position: "Apprentice – Enterprise Technology Services",
        Location: "Bengaluru, India",
        description: "Contributing to enterprise AI modernization initiatives by evaluating and integrating GenAI frameworks, internal AI tooling, and agentic workflows using LangChain and LangGraph. Developing MCP-based integrations to aggregate operational metrics from enterprise platforms such as GitHub Enterprise, DotConnector, and IRIS systems. Building conversational application insights solutions and designing interactive React.js dashboards for operational visibility and analytics.",
        date: "Jan 2026 - Present",
        icon: "Work",
        path: amex,
        width: 50,
        height: 50,
    },
    {
        id: 2,
        Name: "EduSkills Foundation",
        Location: "Virtual Mode",
        description: "As an experience at Eduskills Foundation, collaborating with IBM in the AI domain, I gained fundamental knowledge of AI and NLP. My experience provided a comprehensive understanding of AI fundamentals and NLP basics. I successfully completed a final project focusing on sentiment analysis using a restaurant dataset. This experience not only expanded my expertise in the field but also equipped me with practical skills to analyze sentiments within a specific context.",
        date: "August 2023 - September 2023",
        icon: "Work",
        path:"https://eduskillsfoundation.org/wp-content/uploads/2022/09/LOGO_EduSkills.png",
        width:150,
        height:50,
        buttonlink: "https://github.com/SajjaPremsai/Internships/tree/master/IBM-EduSkills",
    },
];

export default timelineElements;